import { Link } from "react-router-dom";
import { Btn } from "@/components/ui/Btn/Btn";
import { Icon } from "@/components/ui/Icon/Icon";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { Banner, FormShell } from "@/components/auth/FormShell";
import formStyles from "@/components/auth/AuthForm.module.css";

/**
 * Terminal state of the sign-up flow: email is verified, account
 * exists, account is disabled. The user waits for an admin to flip
 * `enabled: true` from /admin/waitlist (admins only).
 */
export function SignUpWaitlist() {
  return (
    <AuthLayout view="signup-waitlist">
      <FormShell title="You’re on the list.">
        <div className={formStyles.stack}>
          <div className={formStyles.waitlistHero}>
            <Icon name="check" size={28} strokeWidth={3} />
          </div>
          <p className={formStyles.muted}>
            We’ve verified your email and saved your workspace name. Access opens in waves
            so each new team gets real onboarding — that usually means a few days, sometimes
            longer when we’re heads-down on a release. We’ll email you when it’s your
            turn.
          </p>
          <Banner variant="info" icon={<Icon name="info" size={14} />}>
            For your security, we don’t reveal whether a specific email is queued. If you
            forget you signed up, just sign up again with the same email.
          </Banner>
          <div className={formStyles.backRow}>
            <Btn variant="secondary" href="/">
              <Icon name="arrow-left" size={12} />
              Back to home
            </Btn>
          </div>
          <div className={formStyles.backRow}>
            <Link to="/pricing" className={formStyles.backLink}>
              See pricing while you wait
            </Link>
          </div>
        </div>
      </FormShell>
    </AuthLayout>
  );
}
